import React, { useState } from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { SaveItem } from "@starberry/myaccount-website-utils"
import _ from 'lodash';

import { propertyDetailUrl, GetPrice, PropertySearchUrl } from "gatsby-theme-starberry-lomondgroup/src/common/utils/property_utils";
import { toCapitalize } from "gatsby-theme-starberry-lomondgroup/src/common/utils/site_utlis";
import { ShowProcessedImage } from 'gatsby-theme-starberry-lomondgroup/src/common/ggfx-client/module/components/show-image';
import imageConfig from "gatsby-theme-starberry-lomondgroup/static/images/config.json"
import ImageModule from "gatsby-theme-starberry-lomondgroup/src/modules/image_module";
import ContentModule from "gatsby-theme-starberry-lomondgroup/src/modules/content_module";
import SearchResultsImagePopup from "gatsby-theme-starberry-lomondgroup/src/components/SalesCard/SearchResultsImagePopup"
import { HeartIcon } from "gatsby-theme-starberry-lomondgroup/src/common/icons";


import { PageLinks } from "../../common/page-links";


const ListView_Newhomes = ({ item, img_type, search_type, offices, userObjects, setViewingLink, setModalShow }) => {

    const location = useLocation();

    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    }

    var department = item.department ? item.department : "residential"
 
    var property_id = item.objectID || item.id;

    var property_url = propertyDetailUrl(department, search_type, item.status, item.slug, item.objectID || item.id);
    //var search_url = PropertySearchUrl(item.department, item.search_type);
    var search_url = location.pathname;

    var img_transforms = imageConfig.property.images.list_view.sizes;
    var thumb_transforms = imageConfig.property.images.thumnail_image.sizes;

    var alt_text = item.display_address + " - " + process.env.GATSBY_SITE_NAME;


    const ImageRenderList = ({ item, image_url, imagename }) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.images_Transforms) {
            processedImages = item?.imagetransforms?.images_Transforms;
        }
        return (
            <ImageModule ImageSrc={image_url} title={item.display_address} altText={item.display_address} imagetransforms={processedImages} ggfx_results={item?.ggfx_results}  renderer="srcSet" imagename={imagename} strapi_id={item.id} />
        )
    }

    //console.log("search_url ===>", search_url)

    var new_homes_name = item.display_address.split(",");
    var building_name = item?.address?.building_name;
    var prop_addr = item.display_address;
    //prop_addr?.shift()

    let officeContact = _.find(offices, function (o) { return _.includes(_.split(o.office_crm_id, ','), item?.office_crm_id); });

    var to_email_id = process.env.GATSBY_BOOK_VIEWING_EMAIL ? process.env.GATSBY_BOOK_VIEWING_EMAIL : officeContact?.email ? officeContact?.email : "";

    const regex = /(<([^>]+)>)/gi;

    return (
        <div className="sales-wrap new_homes" id={item.objectID}>
            <div className="sales-img-wrap">
                <div className={`sales-img ${item?.images?.length > 1 ? "" : "full_wdth"}`}>
                    {/* <img src={item.images1[0]["570x374"]} alt="img" /> */}
                    <Link to={property_url} state={{ search_url }}>
                        {img_type === "no_property" ?
                            <ImageRenderList item={item} image_url={item.images[0]}  />
                            :
                            item.images.length > 0 ?
                                <ShowProcessedImage images={item.images[0]} attr={{ alt: alt_text }} transforms={img_transforms} />
                                :
                                <ImageRenderList item={item} image_url={item.images[0]} imagename={"property.images.list_view"} />
                        }
                    </Link>

                    {/* {
                        (item.status !== "For Sale" && item.status !== "To Let") ? <span className="top-text">
                            {item.status} </span> : ''
                    } */}

                    {item.images.length > 0 &&
                        <span className="bottom-text" onClick={(e) => openLighboxMobile(e, 0)}>
                            <i className="gallery-icon"></i>
                            <span className="text">{item.images.length}</span>
                        </span>
                    }
                </div>

                {/* ======= List View Thumbnail Image ===== */}
                {item.images.length > 1 &&
                    <div className="sm-sales-img-wrap d-none d-lg-block">
                        {item.images.map((img, i) => {
                            if (i > 0) {
                                return (
                                    <Link to={property_url} state={{ search_url }}>

                                        {img_type === "no_property" ?
                                            (i <= 3 &&
                                                <ImageRenderList item={item} image_url={item.images[i]} />
                                            )
                                            :
                                            <ShowProcessedImage images={item.images[i]} attr={{ alt: alt_text }} transforms={thumb_transforms} />
                                        }

                                    </Link>
                                )
                            }

                        })}
                    </div>
                }

                {isOpen && (item?.images && item?.images?.length != 0) && (
                    <SearchResultsImagePopup
                        propertyId={item.objectID || item.id}
                        propertyImage={item?.images}
                        photoIndex={photoIndex}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        largeSize="720x380"
                        largeSize2="570x374"
                        img_type={img_type}
                    />
                )}
            </div>

            <div className="slide-content">
                <Link to={property_url} state={{ search_url }}>
                    <h2>{building_name ? building_name : new_homes_name && new_homes_name[0]}</h2>

                    {/* <div className="d-md-flex title-wrap">
                        <h3>{prop_addr}</h3>
                    </div> */}

                    <div className="content">
                        <p className="highlight-text">From {GetPrice(item.price)}</p>
                    </div>                

                    <div className="icon-wrapper">
                        {/* {parseInt(item.bedroom) > 0 &&
                            <div className="icon-wrap">
                                <i className="icon-bed"></i>
                                <span className="count">{item.bedroom} Bedroom {typeof item?.building === "object" ? toCapitalize(item.building.toString()) : toCapitalize(item.building.toString())}</span>
                            </div>
                        } */}

                        {item?.building?.length > 0 && 
                            <div className="icon-wrap">
                                <span className="count">{toCapitalize(item.building[0])}</span>
                            </div>
                        }

                        {parseInt(item.bedroom) > 0 ?
                            <div className="icon-wrap">
                                <i className="icon-bed"></i>
                                <span className="count">{item.bedroom}</span>
                            </div>
                            :""
                        }

                        {parseInt(item.bathroom) > 0 ?
                            <div className="icon-wrap">
                                <i className="icon-bath"></i>
                                <span className="count">{item.bathroom}</span>
                            </div>
                            :""
                        }

                        {parseInt(item.reception) > 0 ?
                            <div className="icon-wrap">
                                <i className="icon-reception"></i>
                                <span className="count">{item.reception}</span>
                            </div>
                            :""
                        }
                    </div>
                    
                    {(item?.long_description || item?.additional_description) && 
                    <p className="d-none d-md-block short_desc">
                        <span>{item?.long_description?.replace(/<br\s*\/?>/gi, ' ').replace(regex, " ") || item?.additional_description.replace(/<br\s*\/?>/gi, ' ').replace(regex, " ")}</span>
                        {/* {item?.description && <ContentModule Content={item?.description} />} */}

                        {/* <div className="more-link">more</div> */}
                    </p>
                    }
                </Link>

                {
                    <div className="nego_details">

                        <Link to={`/${PageLinks.book_a_viewing}/`} state={{ property_data:{...item, address:item.display_address}, form_type: "book_a_viewing", property_url: property_url, to_email_id }} className="btn btn-primary">
                            <i className="icon-mail"></i>
                            <span className="d-none d-xl-block">Enquire</span>
                            <span className="d-xl-none">Enquire</span>
                        </Link>

                        {officeContact?.mobile && 
                            <a href={`tel:${officeContact?.mobile}`} className={`btn btn-outline ${item?.search_type}`}>
                                <i className="icon-phone"></i>
                                <span className="d-none d-xl-block">{officeContact?.mobile}</span>
                                <span className="d-xl-none">Call</span>
                            </a>
                        }
                    </div>
                }
                <SaveItem type="property" pid={property_id} userObjects={userObjects}>
                    <span className="map-info save-item">
                        <HeartIcon /><span> Save</span><span className="saved-text">d</span>
                    </span>
                </SaveItem>
            </div>
            
        </div>
    );
};
export default ListView_Newhomes;